import { String$, CssRuleWithAuto$reflection, CssRuleWithAuto, None$0027, Normal, CssRule$reflection, CssRule, MasterTypeHelpers_stringifyICssValue } from "./MasterTypes.fs.js";
import { Union } from "../../fable-library.3.7.17/Types.js";
import { class_type, string_type, float64_type, union_type, int32_type } from "../../fable-library.3.7.17/Reflection.js";

export class Percent extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Percent"];
    }
    StringifyFontFace() {
        const this$ = this;
        return MasterTypeHelpers_stringifyICssValue(this$);
    }
    StringifyCss() {
        const this$ = this;
        return `${this$.fields[0]}%`;
    }
}

export function Percent$reflection() {
    return union_type("Fss.Types.Percent", [], Percent, () => [[["Item", int32_type]]]);
}

export class Length extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Px", "In", "Cm", "Mm", "Pt", "Pc", "Em\u0027", "Rem", "Ex", "Ch", "Vw", "Vh", "VMax", "VMin"];
    }
    StringifyCss() {
        const this$ = this;
        switch (this$.tag) {
            case 1: {
                return `${this$.fields[0]}in`;
            }
            case 2: {
                return `${this$.fields[0]}cm`;
            }
            case 3: {
                return `${this$.fields[0]}mm`;
            }
            case 4: {
                return `${this$.fields[0]}pt`;
            }
            case 5: {
                return `${this$.fields[0]}pc`;
            }
            case 6: {
                return `${this$.fields[0]}em`;
            }
            case 7: {
                return `${this$.fields[0]}rem`;
            }
            case 8: {
                return `${this$.fields[0]}ex`;
            }
            case 9: {
                return `${this$.fields[0]}ch`;
            }
            case 10: {
                return `${this$.fields[0]}vw`;
            }
            case 11: {
                return `${this$.fields[0]}vh`;
            }
            case 12: {
                return `${this$.fields[0]}vmax`;
            }
            case 13: {
                return `${this$.fields[0]}vmin`;
            }
            default: {
                return `${this$.fields[0]}px`;
            }
        }
    }
}

export function Length$reflection() {
    return union_type("Fss.Types.Length", [], Length, () => [[["Item", int32_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", float64_type]]]);
}

export class Angle extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Deg", "Grad", "Rad", "Turn"];
    }
    StringifyCss() {
        const this$ = this;
        switch (this$.tag) {
            case 1: {
                return `${this$.fields[0]}grad`;
            }
            case 2: {
                return `${this$.fields[0]}rad`;
            }
            case 3: {
                return `${this$.fields[0]}turn`;
            }
            default: {
                return `${this$.fields[0]}deg`;
            }
        }
    }
}

export function Angle$reflection() {
    return union_type("Fss.Types.Angle", [], Angle, () => [[["Item", float64_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", float64_type]]]);
}

export class Resolution extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Dpi"];
    }
    StringifyCss() {
        const this$ = this;
        return `${this$.fields[0]}dpi`;
    }
}

export function Resolution$reflection() {
    return union_type("Fss.Types.Resolution", [], Resolution, () => [[["Item", string_type]]]);
}

export class Time extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Sec", "Ms"];
    }
    StringifyCss() {
        const this$ = this;
        return (this$.tag === 1) ? (`${this$.fields[0]}ms`) : (`${this$.fields[0]}s`);
    }
}

export function Time$reflection() {
    return union_type("Fss.Types.Time", [], Time, () => [[["Item", float64_type]], [["Item", float64_type]]]);
}

export class Fraction extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Fr"];
    }
    StringifyCss() {
        const this$ = this;
        return `${this$.fields[0]}fr`;
    }
}

export function Fraction$reflection() {
    return union_type("Fss.Types.Fraction", [], Fraction, () => [[["Item", float64_type]]]);
}

export function unitHelpers_lengthPercentageToType(lp) {
    if (lp instanceof Percent) {
        return lp;
    }
    else if (lp instanceof Length) {
        return lp;
    }
    else {
        return new Length(0, 0);
    }
}

export function unitHelpers_lengthPercentageString(lp) {
    if (lp instanceof Percent) {
        return MasterTypeHelpers_stringifyICssValue(lp);
    }
    else if (lp instanceof Length) {
        return MasterTypeHelpers_stringifyICssValue(lp);
    }
    else {
        return "";
    }
}

export class unitHelpers_CssRuleWithLength extends CssRule {
    constructor(property) {
        super(property);
        this.property_1 = property;
    }
}

export function unitHelpers_CssRuleWithLength$reflection() {
    return class_type("Fss.Types.unitHelpers.CssRuleWithLength", void 0, unitHelpers_CssRuleWithLength, CssRule$reflection());
}

export function unitHelpers_CssRuleWithLength_$ctor_Z207A3CFB(property) {
    return new unitHelpers_CssRuleWithLength(property);
}

export function unitHelpers_CssRuleWithLength__value_Z498FEB3B(this$, length) {
    const tupledArg = [this$.property_1, unitHelpers_lengthPercentageToType(length)];
    return [tupledArg[0], tupledArg[1]];
}

export class unitHelpers_CssRuleWithLengthNormal extends unitHelpers_CssRuleWithLength {
    constructor(property) {
        super(property);
        this.property_2 = property;
    }
}

export function unitHelpers_CssRuleWithLengthNormal$reflection() {
    return class_type("Fss.Types.unitHelpers.CssRuleWithLengthNormal", void 0, unitHelpers_CssRuleWithLengthNormal, unitHelpers_CssRuleWithLength$reflection());
}

export function unitHelpers_CssRuleWithLengthNormal_$ctor_Z207A3CFB(property) {
    return new unitHelpers_CssRuleWithLengthNormal(property);
}

export function unitHelpers_CssRuleWithLengthNormal__get_normal(this$) {
    const tupledArg = [this$.property_2, new Normal(0)];
    return [tupledArg[0], tupledArg[1]];
}

export class unitHelpers_CssRuleWithLengthNone extends unitHelpers_CssRuleWithLength {
    constructor(property) {
        super(property);
        this.property_2 = property;
    }
}

export function unitHelpers_CssRuleWithLengthNone$reflection() {
    return class_type("Fss.Types.unitHelpers.CssRuleWithLengthNone", void 0, unitHelpers_CssRuleWithLengthNone, unitHelpers_CssRuleWithLength$reflection());
}

export function unitHelpers_CssRuleWithLengthNone_$ctor_Z207A3CFB(property) {
    return new unitHelpers_CssRuleWithLengthNone(property);
}

export function unitHelpers_CssRuleWithLengthNone__get_none(this$) {
    const tupledArg = [this$.property_2, new None$0027(0)];
    return [tupledArg[0], tupledArg[1]];
}

export class unitHelpers_CssRuleWithAutoLength extends CssRuleWithAuto {
    constructor(property) {
        super(property);
        this.property_2 = property;
    }
}

export function unitHelpers_CssRuleWithAutoLength$reflection() {
    return class_type("Fss.Types.unitHelpers.CssRuleWithAutoLength", void 0, unitHelpers_CssRuleWithAutoLength, CssRuleWithAuto$reflection());
}

export function unitHelpers_CssRuleWithAutoLength_$ctor_Z207A3CFB(property) {
    return new unitHelpers_CssRuleWithAutoLength(property);
}

export function unitHelpers_CssRuleWithAutoLength__value_Z498FEB3B(this$, length) {
    const tupledArg = [this$.property_2, unitHelpers_lengthPercentageToType(length)];
    return [tupledArg[0], tupledArg[1]];
}

export class unitHelpers_CssRuleWithAutoLengthNone extends unitHelpers_CssRuleWithAutoLength {
    constructor(property) {
        super(property);
        this.property_3 = property;
    }
}

export function unitHelpers_CssRuleWithAutoLengthNone$reflection() {
    return class_type("Fss.Types.unitHelpers.CssRuleWithAutoLengthNone", void 0, unitHelpers_CssRuleWithAutoLengthNone, unitHelpers_CssRuleWithAutoLength$reflection());
}

export function unitHelpers_CssRuleWithAutoLengthNone_$ctor_Z207A3CFB(property) {
    return new unitHelpers_CssRuleWithAutoLengthNone(property);
}

export function unitHelpers_CssRuleWithAutoLengthNone__get_none(this$) {
    const tupledArg = [this$.property_3, new None$0027(0)];
    return [tupledArg[0], tupledArg[1]];
}

export class unitHelpers_DirectionalLength extends CssRule {
    constructor(property) {
        super(property);
        this.property_1 = property;
    }
}

export function unitHelpers_DirectionalLength$reflection() {
    return class_type("Fss.Types.unitHelpers.DirectionalLength", void 0, unitHelpers_DirectionalLength, CssRule$reflection());
}

export function unitHelpers_DirectionalLength_$ctor_Z207A3CFB(property) {
    return new unitHelpers_DirectionalLength(property);
}

export function unitHelpers_DirectionalLength__value_Z498FEB3B(this$, length) {
    const tupledArg = [this$.property_1, unitHelpers_lengthPercentageToType(length)];
    return [tupledArg[0], tupledArg[1]];
}

export function unitHelpers_DirectionalLength__value_3202B9A0(this$, vertical, horizontal) {
    const tupledArg = [this$.property_1, new String$(0, `${unitHelpers_lengthPercentageString(vertical)} ${unitHelpers_lengthPercentageString(horizontal)}`)];
    return [tupledArg[0], tupledArg[1]];
}

export function unitHelpers_DirectionalLength__value_Z3BD6069B(this$, top, horizontal, bottom) {
    const tupledArg = [this$.property_1, new String$(0, `${unitHelpers_lengthPercentageString(top)} ${unitHelpers_lengthPercentageString(horizontal)} ${unitHelpers_lengthPercentageString(bottom)}`)];
    return [tupledArg[0], tupledArg[1]];
}

export function unitHelpers_DirectionalLength__value_ZE6CD40(this$, top, right, bottom, left) {
    const tupledArg = [this$.property_1, new String$(0, `${unitHelpers_lengthPercentageString(top)} ${unitHelpers_lengthPercentageString(right)} ${unitHelpers_lengthPercentageString(bottom)} ${unitHelpers_lengthPercentageString(left)}`)];
    return [tupledArg[0], tupledArg[1]];
}

